import { render, staticRenderFns } from "./Seo.vue?vue&type=template&id=2af8840e&scoped=true&"
import script from "./Seo.vue?vue&type=script&lang=js&"
export * from "./Seo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af8840e",
  null
  
)

export default component.exports